import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  Select,
  MenuItem,
} from '@material-ui/core'

class TimeseriesSelect extends React.Component {
  static propTypes = {
    timeseries: PropTypes.array.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: 0,
  }

  static styles = {}

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  render() {
    const {
      value, onChange,
      timeseries, ...props
    } = this.props
    if (timeseries.length > 0) {
      return (
        <Select value={value} onChange={this.onChange} {...props}>
          {timeseries.map((ts) => (
            <MenuItem key={ts.id} value={ts.id}>
              {ts.name} ({ts.device_id} - {ts.sensor_id})
            </MenuItem>
          ))}
        </Select>
      )
    }
    return null
  }
}

export default withStyles(TimeseriesSelect.styles)(TimeseriesSelect)
